/* ============================================================
   SOUK TATTOOS — Complete Theme JS v3
   - Mobile nav (hamburger → full-screen slide panel)
   - Quick order form (posts to Shopify Contact API)
   - Cart drawer + SoukCart engine
   - Animations + gallery + variants + tabs
   ============================================================ */
'use strict';
(function () {

  const DELIVERY = 7;
  const CURRENCY = 'DT';
  const $ = (s, c=document) => c.querySelector(s);
  const $$ = (s, c=document) => [...c.querySelectorAll(s)];
  const fmt = v => (+v || 0).toFixed(2) + ' ' + CURRENCY;

  /* ── 1. STICKY HEADER ─────────────────────────────────── */
  function initHeader() {
    const h = $('#souk-header') || $('.souk-header');
    if (!h) return;
    const onScroll = () => h.classList.toggle('scrolled', scrollY > 48);
    window.addEventListener('scroll', onScroll, {passive:true});
    onScroll();
  }

  /* ── 2. MOBILE NAV ─────────────────────────────────────
     Hamburger → slides in panel from right
     X button, backdrop click, Escape → close
  ───────────────────────────────────────────────────────── */
  function initMobileNav() {
    const hamburger = $('#souk-hamburger');
    const nav       = $('#souk-mobile-nav');
    const backdrop  = $('#souk-nav-backdrop');
    const closeBtn  = $('#souk-mobile-close');

    if (!hamburger || !nav) return;

    function openNav() {
      hamburger.classList.add('is-open');
      hamburger.setAttribute('aria-expanded', 'true');
      nav.classList.add('is-open');
      nav.setAttribute('aria-hidden', 'false');
      backdrop && backdrop.classList.add('active');
      document.body.classList.add('nav-open');
      // Enable tabbing inside nav
      $$('a, button', nav).forEach(el => el.removeAttribute('tabindex'));
    }

    function closeNav() {
      hamburger.classList.remove('is-open');
      hamburger.setAttribute('aria-expanded', 'false');
      nav.classList.remove('is-open');
      nav.setAttribute('aria-hidden', 'true');
      backdrop && backdrop.classList.remove('active');
      document.body.classList.remove('nav-open');
      // Disable tabbing when closed
      $$('a, button', nav).forEach(el => el.setAttribute('tabindex', '-1'));
    }

    hamburger.addEventListener('click', () => {
      nav.classList.contains('is-open') ? closeNav() : openNav();
    });

    closeBtn  && closeBtn.addEventListener('click', closeNav);
    backdrop  && backdrop.addEventListener('click', closeNav);
    document.addEventListener('keydown', e => {
      if (e.key === 'Escape') closeNav();
    });

    // Close nav if a link inside is clicked
    $$('.souk-mobile-link', nav).forEach(link => {
      link.addEventListener('click', closeNav);
    });

    // Initial state — make links not tabbable
    closeNav();
  }

  /* ── 3. SCROLL ANIMATIONS ─────────────────────────────── */
  function initAnimations() {
    if (!('IntersectionObserver' in window)) {
      $$('[data-souk-anim]').forEach(el => el.classList.add('visible'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, {threshold: .12, rootMargin: '0px 0px -40px 0px'});
    $$('[data-souk-anim]').forEach(el => obs.observe(el));
  }

  /* ── 4. PRODUCT GALLERY ───────────────────────────────── */
  function initGallery() {
    const mainImg = $('#souk-main-img');
    if (!mainImg) return;
    $$('.souk-thumb').forEach(t => {
      t.addEventListener('click', () => {
        const src = t.dataset.src;
        if (!src) return;
        mainImg.style.opacity = '0';
        setTimeout(() => { mainImg.src = src; mainImg.style.opacity = '1'; }, 100);
        $$('.souk-thumb').forEach(x => x.classList.remove('active'));
        t.classList.add('active');
      });
    });
  }

  /* ── 5. VARIANT SELECTOR ──────────────────────────────── */
  function initVariants() {
    $$('.souk-vpill').forEach(pill => {
      if (pill.classList.contains('na')) return;
      pill.addEventListener('click', () => {
        const group = pill.closest('[data-variant-group]') || pill.closest('.souk-variant-pills');
        if (group) $$('.souk-vpill', group).forEach(p => p.classList.remove('sel'));
        pill.classList.add('sel');
        const vid   = pill.dataset.variantId;
        const price = pill.dataset.price;
        const vidInput = $('#souk-variant-id');
        if (vid && vidInput) vidInput.value = vid;
        const priceEl = $('#souk-product-price');
        if (price && priceEl) priceEl.textContent = fmt(parseFloat(price)/100);
      });
    });
  }

  /* ── 6. TABS ──────────────────────────────────────────── */
  function initTabs() {
    $$('.souk-tab-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const wrap = btn.closest('.souk-tabs') || document;
        $$('.souk-tab-btn', wrap).forEach(b => b.classList.remove('active'));
        $$('.souk-tab-pane', wrap).forEach(p => p.classList.remove('active'));
        btn.classList.add('active');
        const pane = $('#souk-tab-' + btn.dataset.tab, wrap) || $(`[data-tab-content="${btn.dataset.tab}"]`, wrap);
        pane && pane.classList.add('active');
      });
    });
  }

  /* ── 7. TOAST ─────────────────────────────────────────── */
  function showToast(msg, duration=2800) {
    let t = $('#souk-toast');
    if (!t) {
      t = document.createElement('div');
      t.id = 'souk-toast';
      t.className = 'souk-toast';
      t.setAttribute('role', 'alert');
      t.setAttribute('aria-live', 'polite');
      document.body.appendChild(t);
    }
    t.textContent = msg;
    t.classList.add('show');
    clearTimeout(t._timer);
    t._timer = setTimeout(() => t.classList.remove('show'), duration);
  }
  window.SoukToast = showToast;

  /* ══════════════════════════════════════════════════════
     8. SOUK CART ENGINE
  ════════════════════════════════════════════════════════ */
  const SoukCart = (() => {
    const KEY  = 'souk_cart_v3';
    const load = () => { try { return JSON.parse(sessionStorage.getItem(KEY)) || []; } catch { return []; } };
    const save = c => { try { sessionStorage.setItem(KEY, JSON.stringify(c)); } catch {} };
    const emit = () => document.dispatchEvent(new CustomEvent('souk:cart:update', {detail: SoukCart.getAll()}));

    return {
      add(id, name, price, qty=1, variant='', img='') {
        const cart = load();
        const ex = cart.find(i => i.id === String(id) && i.variant === variant);
        if (ex) ex.qty += qty;
        else cart.push({id: String(id), name, price: +price, qty, variant, img});
        save(cart); emit();
        // Also sync native Shopify cart (for checkout compatibility)
        if (id && !isNaN(id)) {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            body: JSON.stringify({id: parseInt(id), quantity: qty})
          }).catch(() => {});
        }
      },
      remove(id, variant='') {
        save(load().filter(i => !(i.id === String(id) && i.variant === variant)));
        emit();
      },
      update(id, qty, variant='') {
        if (qty <= 0) return this.remove(id, variant);
        const cart = load();
        const item = cart.find(x => x.id === String(id) && x.variant === variant);
        if (item) { item.qty = qty; save(cart); emit(); }
      },
      getAll()  { return load(); },
      totals()  {
        const items = load();
        const sub   = items.reduce((s, i) => s + i.price * i.qty, 0);
        const del   = items.length ? DELIVERY : 0;
        return { sub, delivery: del, total: sub + del, count: items.reduce((s,i) => s+i.qty, 0) };
      },
      clear()   { try { sessionStorage.removeItem(KEY); } catch {} emit(); }
    };
  })();
  window.SoukCart = SoukCart;

  /* ── 9. CART BADGE ────────────────────────────────────── */
  function updateBadges() {
    const { count } = SoukCart.totals();
    $$('.souk-cart-badge').forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  /* ── 10. CART DRAWER RENDER ───────────────────────────── */
  function renderCartDrawer() {
    const drawer  = $('#souk-cart-drawer');
    if (!drawer) return;
    const itemsEl = $('[data-cart-items]', drawer);
    const emptyEl = $('[data-cart-empty]', drawer);
    const footEl  = $('[data-cart-foot]', drawer);
    const subEl   = $('[data-cart-sub]', drawer);
    const totEl   = $('[data-cart-total]', drawer);
    const items   = SoukCart.getAll();
    const {sub, total} = SoukCart.totals();

    if (subEl) subEl.textContent = fmt(sub);
    if (totEl) totEl.textContent = fmt(total);

    if (!items.length) {
      emptyEl && (emptyEl.style.display = 'flex');
      footEl  && (footEl.style.display  = 'none');
      if (itemsEl) itemsEl.innerHTML = '';
      return;
    }
    emptyEl && (emptyEl.style.display = 'none');
    footEl  && (footEl.style.display  = 'block');
    if (!itemsEl) return;

    itemsEl.innerHTML = items.map(i => `
      <div class="souk-ci">
        <div class="souk-ci-img">
          ${i.img
            ? `<img src="${i.img}" alt="${i.name}" loading="lazy">`
            : `<div style="width:100%;height:100%;display:flex;align-items:center;justify-content:center;font-size:1.8rem;">🎨</div>`}
        </div>
        <div class="souk-ci-info">
          <div class="souk-ci-name">${i.name}</div>
          ${i.variant ? `<div class="souk-ci-variant">${i.variant}</div>` : ''}
          <div class="souk-ci-qty">
            <button class="souk-ci-qty-btn" onclick="SoukCart.update('${i.id}',${i.qty-1},'${i.variant}')" aria-label="Diminuer">−</button>
            <input class="souk-ci-qty-val" type="number" value="${i.qty}" min="1" max="99"
              onchange="SoukCart.update('${i.id}',parseInt(this.value)||1,'${i.variant}')">
            <button class="souk-ci-qty-btn" onclick="SoukCart.update('${i.id}',${i.qty+1},'${i.variant}')" aria-label="Augmenter">+</button>
          </div>
          <div class="souk-ci-price">${fmt(i.price * i.qty)}</div>
          <button class="souk-ci-rm" onclick="SoukCart.remove('${i.id}','${i.variant}')">Supprimer</button>
        </div>
      </div>
    `).join('');
  }

  /* ── 11. CART DRAWER TOGGLE ───────────────────────────── */
  function initCartDrawer() {
    const drawer  = $('#souk-cart-drawer');
    const overlay = $('#souk-overlay');
    if (!drawer) return;

    const openCart = () => {
      drawer.classList.add('open');
      overlay && overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
      renderCartDrawer();
    };
    const closeCart = () => {
      drawer.classList.remove('open');
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';
    };

    // $$('[data-cart-open]') listeners supprimés — le bouton panier est maintenant un lien <a href="/cart">
    $$('[data-cart-close]').forEach(b => b.addEventListener('click', closeCart));
    overlay && overlay.addEventListener('click', closeCart);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  }

  /* ── 12. ADD-TO-CART BUTTONS ──────────────────────────── */
  function initAddToCart() {
    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-souk-add]');
      if (!btn) return;
      const id      = btn.dataset.soukAdd || btn.dataset.variantId;
      const name    = btn.dataset.name  || 'Produit';
      const price   = parseFloat(btn.dataset.price  || 0);
      const variant = btn.dataset.variant || '';
      const img     = btn.dataset.img   || '';
      const qty     = parseInt(btn.dataset.qty || 1);
      if (!id) return;
      SoukCart.add(id, name, price, qty, variant, img);
      showToast('✓ Ajouté au panier !');
      btn.classList.add('active');
      setTimeout(() => btn.classList.remove('active'), 2200);
    });
  }

  /* ══════════════════════════════════════════════════════
     13. QUICK ORDER FORM
     - Live price calculation
     - Variant selection
     - Validation with field shake animation
     - Submits via Shopify Contact form (/contact)
       → you receive an email for every order
  ════════════════════════════════════════════════════════ */
  function initQuickOrderForms() {
    $$('[data-quick-form]').forEach(wrap => {
      const basePrice = parseFloat(wrap.dataset.price || 0);
      const pid       = wrap.dataset.productId;
      const pname     = wrap.dataset.productName;

      let qty = 1;

      const qtyDisplay     = $('[data-qf-qty]', wrap);
      const qtyLabelDisp   = $('[data-qf-qty-label]', wrap);
      const qtyHidden      = $('[id^="qf-qty-hidden"]', wrap);
      const totalHidden    = $('[id^="qf-total-hidden"]', wrap);
      const variantHidden  = $('[id^="qf-variant-name"]', wrap);
      const bdProd         = $('[data-qf-prod]', wrap);
      const bdTotal        = $('[data-qf-total]', wrap);
      const formBody       = $('[data-qf-body]', wrap);
      const successDiv     = $('[data-qf-success]', wrap);
      const submitBtn      = $('.souk-qof-submit', wrap);
      const submitLabel    = $('.souk-qof-submit-label', wrap);
      const submitLoading  = $('.souk-qof-loading', wrap);
      const confirmProduct = $('[data-qf-confirm-product]', wrap);
      const confirmTotal   = $('[data-qf-confirm-total]', wrap);

      // Get current price (base + variant delta)
      function currentPrice() {
        const sel   = $('.souk-vpill.sel', wrap);
        const delta = sel ? parseFloat(sel.dataset.delta || 0) : 0;
        return basePrice + delta;
      }

      // Refresh all displayed numbers
      function refreshPrices() {
        const price = currentPrice();
        const prod  = price * qty;
        const total = prod + DELIVERY;
        if (qtyDisplay)    qtyDisplay.textContent    = qty;
        if (qtyLabelDisp)  qtyLabelDisp.textContent  = qty;
        if (qtyHidden)     qtyHidden.value            = qty;
        if (bdProd)        bdProd.textContent         = fmt(prod);
        if (bdTotal)       bdTotal.textContent        = fmt(total);
        if (totalHidden)   totalHidden.value          = fmt(total);

        // Update variant hidden field
        const selPill = $('.souk-vpill.sel', wrap);
        if (variantHidden && selPill) variantHidden.value = selPill.textContent.trim();
      }

      // Qty controls
      $('[data-qf-inc]', wrap)?.addEventListener('click', () => { qty = Math.min(99, qty + 1); refreshPrices(); });
      $('[data-qf-dec]', wrap)?.addEventListener('click', () => { qty = Math.max(1,  qty - 1); refreshPrices(); });

      // Variant pills inside this form
      $$('.souk-vpill', wrap).forEach(p => {
        if (p.classList.contains('na')) return;
        p.addEventListener('click', () => {
          $$('.souk-vpill', wrap).forEach(x => x.classList.remove('sel'));
          p.classList.add('sel');
          refreshPrices();
        });
      });

      // Validate required fields
      function validate() {
        let ok = true;
        $$('[required]', wrap).forEach(input => {
          const empty = !input.value.trim();
          input.classList.toggle('souk-field-error', empty);
          if (empty) { ok = false; input.focus(); }
        });
        return ok;
      }

      // Form submission — sends to Shopify /contact
      const form = $('form', wrap);
      if (!form) return;

      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (!validate()) return;

        const nameInput  = $('[name="contact[name]"]', wrap);
        const phoneInput = $('[name="contact[phone]"]', wrap);
        const addrInput  = $('[name="contact[body]"]', wrap);
        const price      = currentPrice();
        const total      = price * qty + DELIVERY;
        const selPill    = $('.souk-vpill.sel', wrap);
        const variantTxt = selPill ? selPill.textContent.trim() : '';

        // Build a clean order message for the email you receive
        const orderSummary = [
          `📦 NOUVELLE COMMANDE — ${pname}`,
          ``,
          `Client : ${nameInput?.value.trim()}`,
          `Téléphone : ${phoneInput?.value.trim()}`,
          `Adresse : ${addrInput?.value.trim()}`,
          ``,
          `Produit : ${pname}`,
          variantTxt ? `Variante : ${variantTxt}` : '',
          `Quantité : ${qty}`,
          `Prix unitaire : ${fmt(price)}`,
          `Livraison : ${fmt(DELIVERY)}`,
          `TOTAL : ${fmt(total)}`,
          ``,
          `Mode de paiement : Paiement à la livraison (espèces)`,
          `Date : ${new Date().toLocaleString('fr-TN')}`,
        ].filter(Boolean).join('\n');

        // Inject full order into the body field
        if (addrInput) addrInput.value = `Adresse : ${addrInput.value.trim()}\n\n${orderSummary}`;

        // Show loading
        if (submitLabel)   submitLabel.style.display   = 'none';
        if (submitLoading) submitLoading.style.display = 'inline';
        if (submitBtn)     submitBtn.disabled          = true;

        try {
          // Post to Shopify /contact form
          const data = new FormData(form);
          data.set('form_type', 'contact');
          data.set('utf8', '✓');

          const res = await fetch('/contact', {
            method: 'POST',
            body: new URLSearchParams(data),
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          });

          // Also add to SoukCart
          SoukCart.add(pid, pname, price, qty, variantTxt);

          // Show success
          if (formBody)   formBody.style.display    = 'none';
          if (successDiv) {
            successDiv.style.display = 'flex';
            const phoneOut = $('[data-qf-phone-out]', wrap);
            if (phoneOut) phoneOut.textContent = phoneInput?.value.trim() || '';
            if (confirmProduct) confirmProduct.textContent = `${pname}${variantTxt ? ' — ' + variantTxt : ''} × ${qty}`;
            if (confirmTotal)   confirmTotal.textContent   = fmt(total);
          }

          showToast('✓ Commande envoyée ! Nous vous appelons bientôt.');

        } catch (err) {
          // Restore button on error
          if (submitLabel)   submitLabel.style.display   = 'inline';
          if (submitLoading) submitLoading.style.display = 'none';
          if (submitBtn)     submitBtn.disabled          = false;
          showToast('❌ Erreur d\'envoi. Réessayez.', 4000);
          console.error('Order form error:', err);
        }
      });

      // Remove error class on input
      $$('[required]', wrap).forEach(input => {
        input.addEventListener('input', () => input.classList.remove('souk-field-error'));
      });

      // Reset form
      $('[data-qf-reset]', wrap)?.addEventListener('click', () => {
        if (formBody)   formBody.style.display    = 'block';
        if (successDiv) successDiv.style.display  = 'none';
        if (submitLabel)   submitLabel.style.display   = 'inline';
        if (submitLoading) submitLoading.style.display = 'none';
        if (submitBtn)     submitBtn.disabled          = false;
        form.reset();
        $$('[required]', wrap).forEach(i => i.classList.remove('souk-field-error'));
        qty = 1;
        refreshPrices();
      });

      // Init prices
      refreshPrices();
    });
  }

  /* ── 14. ORDER MODAL (from cart drawer) ───────────────── */
  function initOrderModal() {
    const modal     = $('#souk-order-modal');
    const overlay   = $('#souk-overlay');
    if (!modal) return;

    const formDiv   = $('[data-order-form]', modal);
    const successDiv= $('[data-order-success]', modal);

    const openModal = () => {
      const items = SoukCart.getAll();
      if (!items.length) { showToast('Votre panier est vide'); return; }

      const {sub, delivery, total} = SoukCart.totals();
      const itemsEl = $('[data-order-items]', modal);
      if (itemsEl) {
        itemsEl.innerHTML = items.map(i => `
          <div class="souk-modal-item">
            <div><div class="souk-modal-item-name">${i.name}</div>
            <div class="souk-modal-item-sub">${i.variant ? i.variant + ' · ' : ''}Qté : ${i.qty}</div></div>
            <div class="souk-modal-item-price">${fmt(i.price * i.qty)}</div>
          </div>`).join('');
      }
      $('[data-order-sub]',      modal) && ($('[data-order-sub]',      modal).textContent = fmt(sub));
      $('[data-order-delivery]', modal) && ($('[data-order-delivery]', modal).textContent = fmt(delivery));
      $('[data-order-total]',    modal) && ($('[data-order-total]',    modal).textContent = fmt(total));

      modal.classList.add('open');
      overlay && overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    };

    const closeModal = () => {
      modal.classList.remove('open');
      overlay && overlay.classList.remove('active');
      document.body.style.overflow = '';
      setTimeout(() => {
        if (formDiv)    formDiv.style.display    = 'block';
        if (successDiv) successDiv.classList.remove('show');
        modal.querySelector('form')?.reset();
        $$('.souk-input', modal).forEach(i => i.classList.remove('souk-field-error'));
      }, 350);
    };

    $$('[data-order-open]').forEach(b => b.addEventListener('click', openModal));
    $$('[data-order-close]').forEach(b => b.addEventListener('click', closeModal));
    $('[data-modal-bg]', modal)?.addEventListener('click', closeModal);
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeModal(); });

    // Modal form submit
    const form = modal.querySelector('form');
    form?.addEventListener('submit', async e => {
      e.preventDefault();

      const fname   = $('#order-firstname', modal);
      const address = $('#order-address',   modal);
      const phone   = $('#order-phone',     modal);
      let valid = true;
      [fname, address, phone].forEach(inp => {
        if (!inp) return;
        const empty = !inp.value.trim();
        inp.classList.toggle('souk-field-error', empty);
        if (empty) { valid = false; }
      });
      if (!valid) return;

      const items  = SoukCart.getAll();
      const {total} = SoukCart.totals();

      // Build order message
      const orderLines = items.map(i =>
        `• ${i.name}${i.variant ? ' ('+i.variant+')' : ''} × ${i.qty} = ${fmt(i.price*i.qty)}`
      ).join('\n');

      const msg = [
        `📦 COMMANDE PANIER — ${new Date().toLocaleString('fr-TN')}`,
        ``,
        `Client : ${fname?.value.trim()}`,
        `Téléphone : ${phone?.value.trim()}`,
        `Adresse : ${address?.value.trim()}`,
        ``,
        `Articles :`,
        orderLines,
        ``,
        `Livraison : ${fmt(DELIVERY)}`,
        `TOTAL : ${fmt(total)}`,
        ``,
        `Paiement : Espèces à la livraison`,
      ].join('\n');

      try {
        await fetch('/contact', {
          method: 'POST',
          headers: {'Content-Type': 'application/x-www-form-urlencoded'},
          body: new URLSearchParams({
            form_type: 'contact',
            utf8: '✓',
            'contact[name]':    fname?.value.trim()   || '',
            'contact[email]':   'commande@souktattoos.com',
            'contact[phone]':   phone?.value.trim()   || '',
            'contact[subject]': `🛒 Nouvelle commande panier — ${items.length} articles`,
            'contact[body]':    msg
          })
        });
      } catch {}

      if (formDiv)    formDiv.style.display = 'none';
      if (successDiv) successDiv.classList.add('show');
      showToast('✓ Commande envoyée avec succès !');
      SoukCart.clear();
    });

    $('[data-order-reset]', modal)?.addEventListener('click', closeModal);
  }

  /* ── 15. NEWSLETTER ───────────────────────────────────── */
  function initNewsletter() {
    $$('.souk-nl-form, [id="souk-nl-form"]').forEach(form => {
      form.addEventListener('submit', async e => {
        e.preventDefault();
        const email = $('input[type=email]', form)?.value;
        if (!email) return;
        try {
          await fetch('/contact', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: new URLSearchParams({form_type:'customer', 'contact[email]': email, utf8:'✓'})
          });
        } catch {}
        showToast('✓ Merci pour votre inscription !');
        form.reset();
      });
    });
  }

  /* ── 16. COLLECTION SORT ──────────────────────────────── */
  function initSort() {
    const sel = $('#souk-sort');
    if (!sel) return;
    sel.addEventListener('change', () => {
      const url = new URL(location.href);
      url.searchParams.set('sort_by', sel.value);
      location.href = url.toString();
    });
  }

  /* ── EVENTS ───────────────────────────────────────────── */
  document.addEventListener('souk:cart:update', () => {
    updateBadges();
    renderCartDrawer();
  });

  /* ── INIT ─────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initMobileNav();
    initAnimations();
    initGallery();
    initVariants();
    initTabs();
    // initCartDrawer(); // DÉSACTIVÉ — le panier drawer est remplacé par /cart
    // initAddToCart();  // DÉSACTIVÉ — les boutons redirigent vers la fiche produit
    initQuickOrderForms();
    initOrderModal();
    initNewsletter();
    initSort();
    updateBadges();
    renderCartDrawer();
  });

})();

/* ================================================================
   MOBILE DRAWER v2 — Replaces broken initMobileNav()
   Uses new class names: st-burger, st-drawer, st-bd
   ================================================================ */
(function() {
  'use strict';

  function initDrawer() {
    const burger  = document.getElementById('st-burger');
    const drawer  = document.getElementById('st-drawer');
    const bd      = document.getElementById('st-bd');
    const closeBtn= document.getElementById('st-drawer-close');
    const header  = document.getElementById('st-header');

    if (!burger || !drawer) return;

    /* Open */
    function openDrawer() {
      drawer.classList.add('open');
      drawer.setAttribute('aria-hidden', 'false');
      burger.classList.add('open');
      burger.setAttribute('aria-expanded', 'true');
      bd && bd.classList.add('show');
      document.body.style.overflow = 'hidden';
    }

    /* Close */
    function closeDrawer() {
      drawer.classList.remove('open');
      drawer.setAttribute('aria-hidden', 'true');
      burger.classList.remove('open');
      burger.setAttribute('aria-expanded', 'false');
      bd && bd.classList.remove('show');
      document.body.style.overflow = '';
    }

    /* Burger toggle */
    burger.addEventListener('click', function() {
      drawer.classList.contains('open') ? closeDrawer() : openDrawer();
    });

    /* Close button inside drawer */
    closeBtn && closeBtn.addEventListener('click', closeDrawer);

    /* Backdrop click */
    bd && bd.addEventListener('click', closeDrawer);

    /* Escape key */
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('open')) closeDrawer();
    });

    /* Close when any link inside drawer is tapped */
    var drawerLinks = drawer.querySelectorAll('.st-drawer-link');
    drawerLinks.forEach(function(link) {
      link.addEventListener('click', closeDrawer);
    });

    /* Close when cart button inside drawer is tapped */
    var drawerCartBtns = drawer.querySelectorAll('[data-cart-open]');
    drawerCartBtns.forEach(function(btn) {
      btn.addEventListener('click', closeDrawer);
    });

    /* Sticky header shadow on scroll */
    if (header) {
      window.addEventListener('scroll', function() {
        header.classList.toggle('scrolled', window.scrollY > 50);
      }, { passive: true });
    }
  }

  /* Run after DOM ready */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDrawer);
  } else {
    initDrawer();
  }

})();

/* ================================================================
   PRODUCT PAGE — Quick Order Form JS (new pp- classes)
   ================================================================ */
(function(){
  'use strict';

  var DELIVERY = 7;

  function fmt(v){ return (+v||0).toFixed(2) + ' DT'; }

  function initPPForms(){
    document.querySelectorAll('[data-quick-form]').forEach(function(wrap){
      var basePrice = parseFloat(wrap.dataset.price || 0);
      var pid       = wrap.dataset.productId;
      var pname     = wrap.dataset.productName;
      var qty       = 1;

      var qtyEl   = wrap.querySelector('[data-qof-qty]');
      var qtyLbl  = wrap.querySelector('[data-qof-qlbl]');
      var bdProd  = wrap.querySelector('[data-qof-prod]');
      var bdTot   = wrap.querySelector('[data-qof-tot]');
      var totHid  = wrap.querySelector('[name="contact[total]"]');
      var formDiv = wrap.querySelector('[data-qf-body]');
      var succDiv = wrap.querySelector('[data-qf-success]');

      function getPrice(){
        var sel   = wrap.querySelector('.pp-dvpill.sel, .souk-vpill.sel');
        var delta = sel ? parseFloat(sel.dataset.delta || 0) : 0;
        return basePrice + delta;
      }

      function refresh(){
        var p    = getPrice();
        var prod = p * qty;
        var tot  = prod + DELIVERY;
        if(qtyEl)  qtyEl.textContent  = qty;
        if(qtyLbl) qtyLbl.textContent = qty;
        if(bdProd) bdProd.textContent = fmt(prod);
        if(bdTot)  bdTot.textContent  = fmt(tot);
        if(totHid) totHid.value       = fmt(tot);
      }

      // Qty +/-
      wrap.querySelectorAll('[data-qf-dec]').forEach(function(btn){
        btn.addEventListener('click', function(){ qty = Math.max(1, qty-1); refresh(); });
      });
      wrap.querySelectorAll('[data-qf-inc]').forEach(function(btn){
        btn.addEventListener('click', function(){ qty = Math.min(99, qty+1); refresh(); });
      });

      // Variant pills
      wrap.querySelectorAll('.pp-dvpill, .souk-vpill').forEach(function(p){
        if(p.classList.contains('na')) return;
        p.addEventListener('click', function(){
          wrap.querySelectorAll('.pp-dvpill, .souk-vpill').forEach(function(x){ x.classList.remove('sel'); });
          p.classList.add('sel');
          refresh();
        });
      });

      // Clear errors on input
      wrap.querySelectorAll('[required]').forEach(function(inp){
        inp.addEventListener('input', function(){ inp.classList.remove('err'); });
      });

      // Form submit
      var form = wrap.querySelector('form');
      if(!form) return;

      form.addEventListener('submit', async function(e){
        e.preventDefault();
        var nameInp  = form.querySelector('[name="contact[name]"]');
        var phoneInp = form.querySelector('[name="contact[phone]"]');
        var addrInp  = form.querySelector('[name="contact[body]"]');
        var submitBtn= form.querySelector('.pp-of-submit, .souk-qof-submit');

        var ok = true;
        [nameInp, phoneInp, addrInp].forEach(function(inp){
          if(!inp) return;
          if(!inp.value.trim()){ inp.classList.add('err'); ok = false; }
        });
        if(!ok){ return; }

        var p       = getPrice();
        var tot     = p * qty + DELIVERY;
        var sel     = wrap.querySelector('.pp-dvpill.sel, .souk-vpill.sel');
        var variant = sel ? sel.textContent.trim() : '';

        var body = [
          '📦 COMMANDE SOUK TATTOOS — ' + new Date().toLocaleString('fr-TN'),
          '',
          'Client   : ' + (nameInp ? nameInp.value.trim() : ''),
          'Téléphone: ' + (phoneInp ? phoneInp.value.trim() : ''),
          'Adresse  : ' + (addrInp  ? addrInp.value.trim()  : ''),
          '',
          'Produit  : ' + pname + (variant ? ' — ' + variant : ''),
          'Quantité : ' + qty,
          'Prix u.  : ' + fmt(p),
          'Livraison: ' + fmt(DELIVERY),
          'TOTAL    : ' + fmt(tot),
          '',
          'Paiement : Espèces à la livraison'
        ].join('\n');

        if(submitBtn){ submitBtn.disabled = true; submitBtn.textContent = 'Envoi...'; }

        try {
          var fd = new FormData(form);
          fd.set('contact[body]', body);
          fd.set('form_type', 'contact');
          fd.set('utf8', '✓');
          fd.set('contact[subject]', '🛒 Commande — ' + pname);
          await fetch('/contact', {
            method: 'POST',
            headers: {'Content-Type': 'application/x-www-form-urlencoded'},
            body: new URLSearchParams(fd)
          });
        } catch(err){ console.warn('Order error:', err); }

        // Add to cart
        if(window.SoukCart){ window.SoukCart.add(pid, pname, p, qty, variant, ''); }

        // Show success
        if(formDiv) formDiv.style.display = 'none';
        if(succDiv) {
          succDiv.style.display = 'flex';
          var phoneOut = succDiv.querySelector('[data-qf-phone-out]');
          if(phoneOut && phoneInp) phoneOut.textContent = phoneInp.value.trim();
        }

        if(window.SoukToast) window.SoukToast('✓ Commande envoyée ! On vous appelle bientôt.');

        if(submitBtn){ submitBtn.disabled = false; submitBtn.textContent = 'Envoyer ma commande'; }
      });

      // Reset
      wrap.querySelectorAll('[data-qf-reset]').forEach(function(btn){
        btn.addEventListener('click', function(){
          if(formDiv) formDiv.style.display = 'block';
          if(succDiv) succDiv.style.display = 'none';
          form.reset();
          wrap.querySelectorAll('[required]').forEach(function(i){ i.classList.remove('err'); });
          qty = 1;
          refresh();
        });
      });

      refresh();
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', initPPForms);
  } else {
    initPPForms();
  }
})();
